import { useEffect, useState } from 'react';
import { getToken } from '../services/api';
import { useSucursalActiva } from '../context/SucursalActivaContext';

export async function fetchProtectedFile(url, sucursalId = '') {
  const headers = { Authorization: `Bearer ${getToken()}` };
  if (sucursalId && sucursalId !== 'all') headers['X-Sucursal-Activa'] = sucursalId;
  const response = await fetch(url, { headers });
  if (!response.ok) throw new Error(`Archivo no disponible (${response.status})`);
  return response.blob();
}

export function useProtectedFileUrl(url) {
  const { sucursalId } = useSucursalActiva();
  const [state, setState] = useState({ url: '', error: false });
  useEffect(() => {
    if (!url || !url.startsWith('/api/data/archivos/')) {
      setState({ url: url || '', error: false });
      return undefined;
    }
    let active = true;
    let objectUrl = '';
    setState({ url: '', error: false });
    fetchProtectedFile(url, sucursalId).then((blob) => {
      objectUrl = URL.createObjectURL(blob);
      if (active) setState({ url: objectUrl, error: false });
      else URL.revokeObjectURL(objectUrl);
    }).catch(() => { if (active) setState({ url: '', error: true }); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url, sucursalId]);
  return state;
}
